/*** Importations ******************************************************************************/

// Polyfills

import 'mdn-polyfills/NodeList.prototype.forEach';
import 'mdn-polyfills/Element.prototype.matches';
import 'mdn-polyfills/Element.prototype.closest';
import 'mdn-polyfills/CustomEvent';
import 'mdn-polyfills/Node.prototype.prepend';
import 'mdn-polyfills/Node.prototype.append';
import 'mdn-polyfills/Node.prototype.remove';
import 'mdn-polyfills/Object.assign';
import 'partials/stepup-stepdown-polyfill';

import 'classlist-polyfill';
// import 'unfetch/polyfill';
import focusWithin from 'focus-within-polyfill';
import objectFitImages from 'object-fit-images/dist/ofi.es-modules.js';
import smoothscroll from 'smoothscroll-polyfill';


// Libraries

import InfiniteScroll from 'infinite-scroll';
// import fullpage from 'fullpage.js';
// import 'owl.carousel';
import LazyLoad from 'vanilla-lazyload/dist/lazyload.esm.js';
// import * as basicLightbox from 'basiclightbox/src/scripts/main.js';
// import { CountUp } from 'countup.js';
import { tns } from 'tiny-slider/src/tiny-slider.module.js';
import Glide from '@glidejs/glide/dist/glide.esm.js';
import tippy from 'tippy.js/dist/tippy.esm.js';
import GLightbox from 'glightbox/dist/js/glightbox.js';
import flatpickr from 'flatpickr';
import fr from "flatpickr/dist/l10n/fr.js";

import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock/lib/bodyScrollLock.es6.js';


// Scripts Nubee

import * as functions from 'partials/functions.js';
import GoogleMap from 'partials/google-map.js';
import MobileMenu from 'partials/mobile-menu.js';
// import PageMenu from 'partials/page-menu.js';
// import toggleSearchForm from 'partials/toggle-search-form.js';
import imgCheck from 'partials/img-check.js';
// import AjaxPopup from 'partials/ajax-popup.js';
// import NubeeLightbox from 'partials/nubee-lightbox.js';
import placeholderLabelUpdate from 'partials/placeholder-label.js';
import FormValidation from 'partials/form-validation.js';
// import SwipeFinger from 'partials/swipe-finger.js';
import Tabs from 'partials/tabs.js';
import initFlatpickr from 'partials/init-flatpickr.js';

import * as cookiesBar from 'partials/cookies-bar.js';

(function() {
	/*** Application des polyfills *****************************************************************/

	(function() {
		objectFitImages();
		smoothscroll.polyfill();

		if( 'function' != typeof window.Event ) {
			window.Event = CustomEvent;
		}
	}) ();


	/*** Variables globales ************************************************************************/

	window.vWidth = document.documentElement.clientWidth;
	window.vHeight = document.documentElement.clientHeight;

	window.scrollDirection = null;
	functions.calcFixedEls();

	// window.pageMenus = [];

	window.vWidthExceptFixed = document.documentElement.clientWidth - window.fixedElWidth;
	window.vHeightExceptFixed = window.vHeight - window.fixedElHeight;
	window.curScroll = {
		top: document.documentElement.scrollTop || document.body.scrollTop || 0,
		left: document.documentElement.scrollLeft || document.body.scrollLeft || 0,
		topExceptFixed: ( document.documentElement.scrollTop || document.body.scrollTop || 0 ) + window.fixedElHeight,
		leftExceptFixed: ( document.documentElement.scrollLeft || document.body.scrollLeft || 0 ) + window.fixedElWidth,
	};
	window.vCenter = {
		x: window.curScroll.left + ( window.vWidth / 2 ),
		y: window.curScroll.top + ( window.vHeight / 2 ),
		xExceptFixed: window.curScroll.left + ( window.vWidthExceptFixed / 2 ),
		yExceptFixed: window.curScroll.top + ( window.vHeightExceptFixed / 2 ),
	};
	window.ga = window.ga || window._gaq || null;
	window.lastWindowOpened = 0;
	window.scrollDirection = null;

	// Largeur de la scrollbar disponible dans le JS et le CSS
	window.addEventListener( 'load', function() {
		window.scrollbarWidth = functions.getScrollbarWidth();
		document.documentElement.style.setProperty( '--scrollbar-width', window.scrollbarWidth + "px" );
	} );


	// Chaîne traduisible : window.bonesGlobals.i18n.monPlugin.nomDeChaine


	/*** Mise à jour des mesures de l'écran au resize *********************************************/

	window.addEventListener( 'resize', function() {
		window.vWidth = document.documentElement.clientWidth;
		window.vHeight = document.documentElement.clientHeight;
		window.curScroll.top = document.documentElement.scrollTop || document.body.scrollTop;
		window.vCenter.y = window.curScroll.top + ( window.vHeight / 2 );

		window.headerHeight = document.querySelector('.site-header').offsetHeight;
	} );


	/*** Les liens avec ancre qui mènent vers la même page deviennent seulement des ancres ****************/
	// Requiert functions.urlsAreSamePage
	// Requiert functions.arrayAllEqual

	(function() {
		let linksWithHash = document.querySelectorAll('a[href*="#"]');

		linksWithHash.forEach( function( thisLink ) {
			if( functions.urlsAreSamePage({ urls: [ thisLink.href, window.location.href ] }) ) {
				thisLink.href = thisLink.hash;
			}
		} );
	}) ();


	/*** Défiler doucement les liens ancres ****************************************************************/
	// Requiert la fonction functions.smoothScrollTo
	// Ajuster la variable globale window.fixedElHeight

	(function() {
		if( 'function' == typeof functions.smoothScrollTo ) {
			document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach( function( thisEl ) {
				thisEl.addEventListener( 'click', function( event ) {
					if( 1 == event.which && ! this.classList.contains('no-smooth-scroll') ) {
						let theHash;

						event.preventDefault();
						theHash = this.getAttribute('href');
						functions.smoothScrollTo({ target: theHash });
					}
				} );
			});
		}
	}) ();


	/*** Ne rien faire au clic sur un lien vide (#) *********************************************************/

	(function() {
		document.addEventListener( 'click', function( event ) {
			if( 1 == event.which ) {
				let linkClicked = event.target.closest('a');
				let theHref = linkClicked ? linkClicked.getAttribute('href') : null;

				if( linkClicked && ( ! theHref || '#' == theHref ) ) {
					event.preventDefault();
				}
			}
		} );
	}) ();


	/*** Images et backgrounds différents selon la taille de l'écran *****************************/
	// Requiert img-check.js

	(function() {
		if( 'function' == typeof imgCheck ) {
			window.addEventListener( 'resize', imgCheck );
			imgCheck();
		}
	}) ();


	/*** Lazy load des images et backgrounds ****************************************************************/
	// Requiert vanilla-lazyload

	(function() {
		window.siteLazyLoad = new LazyLoad({
			elements_selector: '.lazy',
			class_loading: 'lazy-loading',
			class_loaded: 'lazy-loaded',
			class_error: 'lazy-error',
			callback_loaded: function( element ) {
				element.style.paddingTop = '';
			},
		});
	}) ();


	/*** Sécurité pour les liens "nouvel onglet" ***********************************************************/


	(function() {
		document.addEventListener( 'click', function( event ) {
			if( 1 == event.which || 2 == event.which ) {
				let linkClicked = event.target.closest('a:not(.no-tab-security)');
				let linkTarget = linkClicked ? linkClicked.getAttribute('target') : null;
				let newWindow;
				let targetRegex = new RegExp( /^(_blank|_new)$/, 'i' )

				if( linkTarget && targetRegex.test( linkTarget ) ) {
					let linkUrl = linkClicked.getAttribute('href');

					event.preventDefault();
					newWindow = window.open( linkClicked.getAttribute('href'), 'targetBlankWindow_' + window.lastWindowOpened );

					++ window.lastWindowOpened;

					if( newWindow ) {
						newWindow.opener = null;
					}
				}
			}
		} );
	}) ();


	/*** Google Maps ***************************************************************************************/
	// Requiert google-map.js

	(function() {
		let mapParents = document.querySelectorAll('.the-map');
		// https://snazzymaps.com/style/53/flat-map
		// Modifié
		let mapStyles = [
			{
				"featureType": "landscape",
				"elementType": "all",
				"stylers": [
					{
						"visibility": "on"
					},
					{
						"color": "#f3f4f4"
					}
				]
			},
			{
				"featureType": "landscape.man_made",
				"elementType": "geometry",
				"stylers": [
					{
						"weight": 0.9
					},
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "poi.park",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"visibility": "on"
					},
					{
						"color": "#83cead"
					}
				]
			},
			{
				"featureType": "road",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"visibility": "on"
					},
					{
						"color": "#ffffff"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"visibility": "on"
					},
					{
						"color": "#facf5a"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"visibility": "on"
					},
					{
						"color": "#233142"
					}
				]
			},
			{
				"featureType": "road.arterial",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"visibility": "on"
					},
					{
						"color": "#facf5a"
					}
				]
			},
			{
				"featureType": "road.arterial",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"visibility": "on"
					},
					{
						"color": "#233142"
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "all",
				"stylers": [
					{
						"visibility": "on"
					},
					{
						"color": "#6eb2ba"
					}
				]
			}
		];

		mapParents.forEach( function( thisParent ) {
			let map = new GoogleMap({
				mapParent: thisParent,
				styles: mapStyles,
				markerIconUrl: window.bonesGlobals.themeDir + '/library/images/map-marker.png'
			});
		} );
	}) ();


	/*** Antispam maison sur les commentaires *************************************************************/
	// À moins d'avoir activé le JS, la validation PHP refusera le commentaire.

	(function() {
		let commentForms = document.querySelectorAll('#commentform');

		commentForms.forEach( function( thisForm ) {
			thisForm.addEventListener( 'submit', function() {
				let legitInput = document.createElement( 'input' );
				legitInput.setAttribute( 'type', 'hidden' );
				legitInput.setAttribute( 'name', 'is_legit' );
				legitInput.value = 1;

				thisForm.appendChild( legitInput );
			} );
		} );
	}) ();


	/*** Validation de formulaire *************************************************************************/
	(function() {
		document.querySelectorAll( '.validate-form' ).forEach( function( thisForm ) {
			let formValidation = new FormValidation({
				form: thisForm,
			});
		} );
	}) ();


	/*** Placeholder labels - Un placeholder qui se tasse quand on écrit **********************************/
	// Requiert la classe sweet-form sur le formulaire
	// Requiert placeholder-label.js

	(function() {
		document.querySelectorAll('.has-placeholder-label input, .has-placeholder-label textarea').forEach( function( thisEl ) {
			placeholderLabelUpdate( thisEl );

			[ 'load', 'focus', 'blur', 'change', 'input' ].forEach( function( eventName ) {
				thisEl.addEventListener( eventName, placeholderLabelUpdate );
			} );
		} );
	}) ();


	/*** Faire afficher le nom du fichier dans les champs input stylisés **********************************/
	(function() {
		let inputs = document.querySelectorAll( '.hidden-file-input' );
		Array.prototype.forEach.call( inputs, function( input ) {
			let label	 = input.nextElementSibling.querySelector('.file-input-label'),
				labelVal = label.innerHTML;

			input.addEventListener( 'change', function( e ) {
				let fileName = '';
				if( this.files && this.files.length > 1 ) {
					fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
				} else {
					fileName = e.target.value.split("\\").pop();
				}

				if( fileName ) {
					label.innerHTML = fileName;
				} else {
					label.innerHTML = labelVal;
				}
			});
		});
	}) ();

	/*** Retour en haut ***********************************************************************************/
	// Requiert functions.smoothScrollTo

	(function() {
		let backToTop = document.querySelector('.back-to-top');

		if( backToTop ) {
			backToTop.addEventListener( 'click', function() {
				if( 1 == event.which ) {
					functions.smoothScrollTo({ target: document.body });
				}
			} );
		}
	}) ();


	/*** Menu mobile maison *******************************************************************************/

	(function() {
		window.mobileMenu = new MobileMenu({
			menuSel: '.mobile-menu',
			buttonSel: '.mobile-menu-button',
			debug: false,
			dropdownParentLinkActive: true,
			// viewportMax: { width: 699 },
		});
	}) ();


	/*** Regroupement d'évènements à intervalles réguliers ************************************************/
	// Plus performant qu'un évènement scroll

	(function() {
		let illustratedSliderCards = document.querySelectorAll('.slider-nav-cards'),
			illustratedSliderCardsProps = [];

		illustratedSliderCards.forEach(function( thisSlider, index ){
			let thisSliderTop = functions.getElementOffset(thisSlider).top - 75,
				thisSliderHeight = thisSlider.offsetHeight + 75;

			illustratedSliderCardsProps[index] = {
				top: thisSliderTop,
				bottom: thisSliderTop + thisSliderHeight,
				height: thisSliderHeight,
				currentClass: 'scroll-0'
			};
		});

		window.scrollInterval = setInterval(function() {
			let lastScroll = window.curScroll;

			window.curScroll = {
				top: document.documentElement.scrollTop || document.body.scrollTop || 0,
				left: document.documentElement.scrollLeft || document.body.scrollLeft || 0,
				bottom: ( document.documentElement.scrollTop || document.body.scrollTop || 0 ) + window.vHeight,
			};
			window.vCenter = {
				x: window.curScroll.left + ( window.vWidth / 2 ),
				y: window.curScroll.top + ( window.vHeight / 2 ),
			};

			if( window.curScroll.top != lastScroll.top ) {
				/*** Glissement vers le haut et fade-in d'éléments ***/
				// Requiert la fonction functions.smoothFadeIn
				if( 'function' == typeof functions.smoothFadeIn ) {
					functions.smoothFadeIn();
				}

				// window.pageMenus.forEach( function( thisMenu ) {
				// 	thisMenu.update();
				// } );

				if( window.curScroll.top > lastScroll.top ) {
					window.scrollDirection = 'down';
					document.body.classList.add('scrolling-down');
					document.body.classList.remove('scrolling-up');
					window.scrollDirection = 'down';
				} else if( window.curScroll.top < lastScroll.top ) {
					window.scrollDirection = 'up';
					document.body.classList.add('scrolling-up');
					document.body.classList.remove('scrolling-down');
					window.scrollDirection = 'up';
				}
			}

			// Classes sur le body pour faire changer des CSS en fonction du scroll

			if( window.curScroll.top > 550 ) {
				document.body.classList.add('scrolled-a-lot');
			} else {
				document.body.classList.remove('scrolled-a-lot');
			}

			if( window.curScroll.top > 120 ) {
				document.body.classList.add('scrolled-a-bit');
			} else {
				document.body.classList.remove('scrolled-a-bit');
			}


			if( window.vWidth >= 921 ) {
				illustratedSliderCards.forEach(function( thisSlider, index ){
					// Faire apparaître les cards des caroussels illustrés

					let windowBottomScroll = window.curScroll.bottom,
						currentScroll = window.curScroll.bottom - illustratedSliderCardsProps[index].top,
						animationHeight = illustratedSliderCardsProps[index].height;

					if( windowBottomScroll >= illustratedSliderCardsProps[index].top && windowBottomScroll < illustratedSliderCardsProps[index].bottom ) {
						let progressionPercent = Math.ceil( currentScroll * 100 / animationHeight ),
							nextDecade = Math.ceil( ( progressionPercent + 1 ) / 10 ) * 10,
							currentClass;

						nextDecade = nextDecade <= 100 ? nextDecade : 100;
						currentClass = 'scroll-' + nextDecade;

						if( !thisSlider.classList.contains(currentClass) ) {
							thisSlider.classList.remove( illustratedSliderCardsProps[index].currentClass );
							thisSlider.classList.add(currentClass);
							illustratedSliderCardsProps[index].currentClass = currentClass;
						}
					} else if( windowBottomScroll < illustratedSliderCardsProps[index].top && !thisSlider.classList.contains('scroll-0') ) {
						thisSlider.classList.remove( illustratedSliderCardsProps[index].currentClass );
						thisSlider.classList.add('scroll-0');
						illustratedSliderCardsProps[index].currentClass = 'scroll-0';
					} else if( windowBottomScroll > illustratedSliderCardsProps[index].bottom && !thisSlider.classList.contains('scroll-100') ) {
						thisSlider.classList.remove( illustratedSliderCardsProps[index].currentClass );
						thisSlider.classList.add('scroll-100');
						illustratedSliderCardsProps[index].currentClass = 'scroll-100';
					}

				});
			}


			// Recalcul des éléments fixes (qui influent sur les smoothScrollTo)
			functions.calcFixedEls();
		}, 100 );
	}) ();


	/*** Recherche qui s'ouvre/ferme en cliquant sur la loupe *********************************************/
	// Requiert toggle-search-form.js

	/*
	(function() {
		if( 'undefined' !== typeof toggleSearchForm ) {
			document.querySelectorAll('.search-form .search-button').forEach( function( thisEl ) {
				thisEl.addEventListener( 'click', function() {
					if( 1 == event.which ) {
						if( ! thisEl.closest('.search-form').classList.contains('open') ) {
							toggleSearchForm( event );
						} else {
							thisEl.closest('form').submit();
						}
					}
				} );
			} );
		}
	}) ();
	*/



	/*** Infinite Scroll - Charger les prochains articles automatiquement *******************************/
	// Requiert jQuery
	// Requiert infinite-scroll.pkgd.min.js

	(function() {
		let infiniteContainers = document.querySelectorAll('.infinite-scroll');

		infiniteContainers.forEach(function( thisEl ) {
			if( thisEl.parentNode.querySelector('.pagination .next') ) {
				let infiniteInstance = new InfiniteScroll(
					'.infinite-scroll',
					{
						path: '.pagination .next',
						append: '.infinite-scroll-element',
						prefill: false,
						history: false,
						// outlayer: outlayer,
						hideNav: '.pagination',
						status: '.infinite-scroll-status',
						debug: false,
					}
				);

				infiniteInstance.on( 'append', function( event, response, path, items ) {
					thisEl.parentNode.querySelector('.infinite-scroll-status').style.display = 'none';
					imgCheck();
					window.siteLazyLoad.update();
				} );
			}
		});
	}) ();


	/*** Dropdown de médias sociaux ***********************************************************************/

	(function() {
		document.addEventListener( 'click', function( event ) {
			if( 1 == event.which ) {
				let buttonClicked = event.target.closest('.more-networks-button');
				let theContainer;
				let theDropdown;

				if( buttonClicked ) {
					let theContainer = buttonClicked.closest( '.more-networks' );
					let theDropdown = theContainer.querySelector( '.more-networks-dropdown' );

					if( ! theContainer.classList.contains('animating') ) {
						theContainer.classList.add( 'animating' );

						if( ! theContainer.classList.contains( 'open' ) ) {
							theContainer.classList.add( 'open' );

							theDropdown.addEventListener( 'transitionend', function fadeInOver( event ) {
								theContainer.classList.remove( 'animating' );
								theDropdown.removeEventListener( 'transitionend', fadeInOver );
							} );

						} else {
							theContainer.classList.remove( 'open' );

							theDropdown.addEventListener( 'transitionend', function fadeOutOver( event ) {
								theContainer.classList.remove( 'animating' );
								theDropdown.removeEventListener( 'transitionend', fadeOutOver );
							} );
						}
					}
				}
			}
		} );
	}) ();


	/*** Sliders Glide *************************************************************************************/
	// Requiert Glide (@glidejs/glide)
	// Ce slider n'a pas de fonction tout-en-un disponible.

	// link-slider
	(function() {
		let linkSliders = document.querySelectorAll('.page-block-link-slider .glide-slider');

		linkSliders.forEach( function( sliderEl ) {	
			let sliderOptions = {
				type: 'slider',
				perView: 4,
				gap: 30,
				bound: true,
				rewind: true,
				// touchAngle: 35,
				peek: {
					before: 0,
					after: 0,
				},
				breakpoints: {
					2200: {
						perView: 3,
						peek: {
							before: 0,
							after: 80,
						},
					},
					1800: {
						perView: 2,
						peek: {
							before: 0,
							after: 80,
						},
					},
					1400: {
						perView: 2,
						peek: {
							before: 0,
							after: 80,
						},
					},
					1000: {
						perView: 2,
						peek: {
							before: 0,
							after: 50,
						},
					},
					700: {
						perView: 1,
						peek: {
							before: 0,
							after: 40,
						},
					},
					500: {
						perView: 1,
						gap: 20,
						peek: {
							before: 0,
							after: 20,
						},
					},
				},
			};

			let sliderInstance = new Glide( sliderEl, sliderOptions );

			sliderInstance.on( 'move', function( moveAmount ) {
				if( moveAmount && moveAmount.movement ) {
					window.siteLazyLoad.update();
					sliderEl.classList.add( 'slider-animating' );
				}
			} );

			sliderInstance.on( 'move.after', function( moveAmount ) {
				window.siteLazyLoad.update();
				sliderEl.classList.remove( 'slider-animating' );
			} );

			document.addEventListener( 'click', function( event ) {
				let inactiveOverlay = event.target.closest( '.inactive-overlay' );

				if( inactiveOverlay ) {
					event.preventDefault();
					sliderInstance.go('>');
				}
			} );

			sliderInstance.mount();
		} );
	}) ();


	// room-slider
	(function() {
		let linkSliders = document.querySelectorAll('.page-block-room-slider .glide-slider');

		linkSliders.forEach( function( sliderEl ) {			
			let sliderOptions = {
				type: 'slider',
				perView: 1,
				gap: 0,
				bound: true,
				rewind: true,
			};

			let sliderInstance = new Glide( sliderEl, sliderOptions );

			sliderInstance.on( 'move', function( moveAmount ) {
				window.siteLazyLoad.update();
				sliderEl.classList.add( 'slider-animating' );
			} );

			sliderInstance.on( 'move.after', function( moveAmount ) {
				window.siteLazyLoad.update();
				sliderEl.classList.remove( 'slider-animating' );
			} );

			sliderInstance.mount();
		} );
	}) ();




	/*** Sliders Tiny Slider *******************************************************************************/
	// Requiert tns (tiny-slider)
	// Requiert la fonction functions.initSliderTiny

	(function() {
		document.querySelectorAll('.tiny-slider').forEach( function( thisEl ) {
			functions.initSliderTiny( thisEl );
		} );
	}) ();


	/*** Ajustement de la hauteur des éléments plein écran aux barres de navigation iOS etc. ****************/

	(function() {
		window.addEventListener( 'load', function( event ) {
			let fullScreenEls = document.querySelectorAll('.full-screen-height');

			fullScreenEls.forEach( function( thisEl ) {
				thisEl.style.minHeight = ( window.innerHeight - window.fixedElHeight - window.headerHeight ) + 'px';
			} );
		} );
	}) ();


	/*** Empêcher la taille d'un élément de se réajuster une fois le chargement terminé ********************/

	(function() {
		let lockedHeightEls = document.querySelectorAll('.lock-height-on-load');

		window.addEventListener( 'load', function( event ) {
			lockedHeightEls.forEach( function( thisEl ) {
				thisEl.style.height = thisEl.offsetHeight + 'px';
				thisEl.style.minHeight = 0;
				thisEl.style.maxHeight = 'none';
			} );
		} );
	}) ();


	/*** Polyfill pseudo-sélecteur CSS :focus-within *******************************************************/
	// Requiert focus-within
	// Il ne s'active que si le navigateur ne supporte pas le pseudo-sélecteur.

	(function() {
		focusWithin.polyfill();
	}) ();


	/*** Select qui redirigent quand on choisit une option ***************************************************/
	// Requiert functions.urlsAreSamePage
	// Requiert functions.arrayAllEqual

	(function() {
		let linkSelects = document.querySelectorAll('.link-select');

		linkSelects.forEach( function( thisSelect ) {
			[ 'change', 'keypress' ].forEach( function( eventName ) {
				thisSelect.addEventListener( eventName, function() {
					let selectedOption = thisSelect.options[ thisSelect.selectedIndex ];
					let targetUrl = selectedOption.dataset.url;

					if( targetUrl ) {
						if( /^#.+/.test( targetUrl ) ) {
							functions.smoothScrollTo({ target: targetUrl });
						} else if( ! functions.urlsAreSamePage({ urls: targetUrl }) ) {
							window.location.href = targetUrl;
						}
					}
				} );
			} );
		} );
	}) ();


	/*** Activation du doigt indicateur de scroll sur les blocs de statistiques appropriés *******************/
	// Requiert swipe-finger.js

	/*
	(function() {
		if( 'undefined' !== typeof SwipeFinger ) {
			let fingerWrappers = document.querySelectorAll('.swipe-finger-wrapper');
			fingerWrappers.forEach( function( thisWrapper ) {
				let swipeFinger = new SwipeFinger({
					wrapper: thisWrapper,
					debug: false,
				});
			} );
		}
	}) ();
	*/


	/*** Défiler doucement au chargement d'une URL avec ancre ***********************************************/
	// Ajoute l'évènement "initialscrollend" pour dire que la page est chargée ET l'ancre active est scrollée
	// Requiert la fonction functions.smoothScrollTo

	(function() {
		if( 'function' == typeof functions.smoothScrollTo ) {
			let origHash = window.location.hash;
			let scrollEndEvent = new Event( 'initialscrollend' );

			if( origHash ) {
				let targetEl = document.querySelector( origHash );

				if( targetEl ) {
					// Blocage du jump du navigateur par défaut
					setTimeout( function() {
						window.location.hash = '';
						functions.removeHash();
					}, 1 )

					window.addEventListener( 'load', function() {
						window.addEventListener( 'smoothscrollend', function initialScrollEnd() {
							window.dispatchEvent( scrollEndEvent );
							window.removeEventListener( 'smoothscrollend', initialScrollEnd );
						} );

						if( origHash ) {
							functions.smoothScrollTo({
								target: origHash,
							});
						}
					});
				} else {
					window.dispatchEvent( scrollEndEvent );
				}
			} else {
				window.dispatchEvent( scrollEndEvent );
			}
		}
	}) ();


	/*** Donner la même hauteur à un groupe d'éléments *******************************************************/

	(function() {
		window.addEventListener( 'load', function() {
			let sameHeightGroups = document.querySelectorAll('.same-height-group');

			sameHeightGroups.forEach( function( thisGroup ) {
				let minWidth = thisGroup.dataset.sameHeightMinWidth || 0;
				let sameHeightEls = thisGroup.querySelectorAll('.same-height');
				let highestHeight = 0;

				if( window.vWidth >= minWidth ) {
					sameHeightEls.forEach( function( thisEl ) {
						highestHeight = Math.max( thisEl.clientHeight, highestHeight );
					} );

					sameHeightEls.forEach( function( thisEl ) {
						thisEl.style.minHeight = highestHeight + 'px';
					} );
				}
			} );
		} );
	}) ();


	/*** Onglets ******************************************************************************************/
	// Requiert tabs.js

	(function() {
		let tabsContainers = document.querySelectorAll('.tabs-block');

		tabsContainers.forEach( function( thisEl ) {
			let tabs = new Tabs({
				container: thisEl,
				debug: false,
			});
		} );
	}) ();


	/*** Tooltips tippy **********************************************************************************/
	// Requiert tippy.js

	(function() {
		tippy( '[data-tippy-content]', {
			theme: 'light',
			flipBehavior: [ 'bottom', 'left' ],
		} );
	}) ();


	/*** Lightbox et popups avec GLightbox ***************************************************************/
	// Requiert GLightbox (glightbox)
	// Requiert functions.initLightboxes

	(function() {
		functions.initLightboxes();
	}) ();


	/*** Boutons +/- des input type number ****************************************************************/
	// Requiert functions.initNumberInput

	(function() {
		let inputs = document.querySelectorAll('.input-number');

		inputs.forEach( function( thisInput ) {
			functions.initNumberInput( thisInput );
		} );
	}) ();


	/*** Formulaire de réservation - Ouverture/fermeture *************************************************/

	(function() {
		let bookingForms = document.querySelectorAll('.booking-form');

		bookingForms.forEach( function( thisForm ) {
			let formButton = thisForm.querySelector('.toggle-booking-form');

			formButton.addEventListener( 'click', function() {
				thisForm.classList.toggle('open');
			} );
		} );
	}) ();


	/*** Formulaire de réservation - Gestion des champs hidden ********************************************/

	(function() {
		let bookingForms = document.querySelectorAll('.booking-form');

		bookingForms.forEach( function( thisForm ) {
			// Remplissage des champs reliés aux enfants
			(function() {
				let nbField = thisForm.querySelector('.booking-nbchd');
				let childFields = [];

				if( nbField ) {
					childFields.push( thisForm.querySelector('input[name="ages1"]') );
					childFields.push( thisForm.querySelector('input[name="ages2"]') );
					childFields.push( thisForm.querySelector('input[name="ages3"]') );
					childFields.push( thisForm.querySelector('input[name="ages4"]') );

					functions.bookingCountChildren( nbField, childFields );
					
					nbField.addEventListener( 'change', function( event ) {
						functions.bookingCountChildren( event.target, childFields );
					} );
				}

			}) ();
		} );
	}) ();


	/*** Datepickers avec flatpickr ************************************************************************/
	// Requiert initFlatpickr (init-flatpickr.js)
	// Requiert flatpickr

	(function() {
		let dateFields = document.querySelectorAll('.input-date');

		dateFields.forEach( function( thisField ) {
			initFlatpickr( thisField );
		} );
	}) ();


	/*** Boutons/liens de réservation soumettent directement le formulaire  *********************************/
	// Requiert functions.getElementByHash

	(function() {
		let bookingLinks = document.querySelectorAll('a[href$="#booking-form"]');

		bookingLinks.forEach( function( thisLink ) {
			// Désactive des scripts par défaut pour liens nouvel onglet/hash
			thisLink.classList.add( 'no-smooth-scroll' );
			thisLink.classList.add( 'no-tab-security' );

			thisLink.addEventListener( 'click', function( event ) {
				event.preventDefault();

				let bookingForm = functions.getElementByHash( thisLink.hash );
				let submitButton = bookingForm.querySelector('.submit-button');

				if( submitButton ) {
					submitButton.click();
				}
			} );
		} );
	}) ();

	/*** Gestion des préférence de cookies ***************************************/
	(function() {
		window.acceptedCookies = cookiesBar.getCookie('acceptedCookies');

		if( 'function' == typeof cookiesBar.cookieConsent ) {
			cookiesBar.cookieConsent();
		}
	}) ();


}) ();